import React from 'react';
import DynamicLabelInput from './DynamicLabelInput';

const SelectField = ({ input, label, showSuccess, defaultValue, options, type, meta: { asyncValidating, touched, error, valid, invalid, warning } }) => 
{

var field = (<DynamicLabelInput {...input} 
              type='select'
              className={options.filter((option) => option.id === parseInt(input.value, 10)).length !== 0 ? 'form-control selected-field' : 'form-control'}
              showLabel={(process.env.PAGE === 'montemar' || process.env.PAGE === 'montemar-adelantos')} 
              placeholder={defaultValue} >
                {defaultValue && (<option value={false}>{ defaultValue }</option>)}
                    {options.map((option, index) => (
                <option className={ "pd-option-item" } key={option.id} value={option.id} >{option.name}</option>
            ))}</DynamicLabelInput>)

if (type === 'hidden') {

    field = (<div className={`form-group ${touched && invalid ? 'has-error' : ''} ${touched && valid && showSuccess ? 'has-success' : ''}`}>
                <div className={asyncValidating ? 'async-validating' : ''}>
                    <DynamicLabelInput {...input} className="form-control"  placeholder={label} type={type}/>
                </div>
            </div>)
}

return (
  <div className={`form-group ${touched && invalid ? 'has-error' : ''} ${touched && valid && showSuccess ? 'has-success' : ''}`}>
    <div className={asyncValidating ? 'async-validating' : ''}>
        {field}
        <div className="help-block">
        {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
  </div>)
}
export default SelectField;



/** WEBPACK FOOTER **
 ** ./src/components/SelectField.js
 **/